import { render, staticRenderFns } from "./AddEditBlMor.vue?vue&type=template&id=534c82e2"
import script from "./AddEditBlMor.vue?vue&type=script&lang=js"
export * from "./AddEditBlMor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports